import apiClient from "config/apiClient";
import Notify from "config/notify";
import {
  MstItemOptionSelectRequest,
  MstItemOptionSelectResponse,
  MstItemOptionUpdate,
  MstItemOptionUpdateResponse,
  MstItemPructureProtectUpdate,
  MstItemPructureProtectUpdateResponse,
  MstPunctureProtectionSelectResponse,
} from "../types/option";

/**
 *  get option list
 */
export async function getOptionListApi(
  body: MstItemOptionSelectRequest = {},
): Promise<{
  data: MstItemOptionSelectResponse["list"];
  total: number;
}> {
  const res = await apiClient.post<MstItemOptionSelectResponse>(`/mst/item/option/select`, body);
  return {
    data: res.data?.list ?? [],
    total: Number(res.data?.total) || 0,
  };
}

/**
 *  get option list
 */
export async function getPructureProtectionApi(): Promise<MstPunctureProtectionSelectResponse> {
  const res = await apiClient.post<MstPunctureProtectionSelectResponse>(
    `/mst/puncture/protection/select`,
    {},
  );
  return { list: res.data?.list ?? [], total: Number(res.data?.total) || 0 };
}

/**
 * Updates the item option.
 * 
 * @param {MstItemOptionUpdate} body - The body of the update request.
 * @returns {Promise<MstItemOptionUpdateResponse>} The response of the update request.
 */
export async function updateOptionApi(
  body: MstItemOptionUpdate,
): Promise<MstItemOptionUpdateResponse> {
  const res = await apiClient.post<MstItemOptionUpdateResponse>(`/mst/item/option/update`, body);
  // if (res.data?.result) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
  return { result: res.data?.result ?? 0 };
}

/**
 * Updates the puncture protection.
 * 
 * @param {MstItemPructureProtectUpdate} body - The body of the update request.
 * @returns {Promise<MstItemPructureProtectUpdateResponse>} The response of the update request.
 */
export async function updatePructureProtectionApi(
  body: MstItemPructureProtectUpdate,
): Promise<MstItemPructureProtectUpdateResponse> {
  const res = await apiClient.post<MstItemPructureProtectUpdateResponse>(`/mst/puncture/protection/update`, body);
  // if (res.data?.result) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
  return { result: res.data?.result ?? 0 };
}
